import { combineReducers } from "redux";
import { List, Map, fromJS, OrderedMap } from "immutable";
import store from "store";
import { config, qaLinks } from "../config";
import {
  GET_GAMES,
  RECEIVE_GAMES,
  RECEIVE_OGA_INFORMATION,
  SET_LAUNCH_OPTIONS,
  SET_LAUNCH_ERROR,
  SET_URL_LAUNCH_OPTIONS,
  FILTER_GAMES,
  TOGGLE_FAVOURITE_GAME,
  SET_SORT_A_TO_Z,
  SET_SORT_Z_TO_A,
  SET_FILTER_MODE_TO_ALL,
  SET_FILTER_MODE_TO_REAL,
  SET_FILTER_MODE_TO_DEMO,
} from "../actions/actions.js";

const min = 1;
const max = config.get("max_users");
const tokenID = Math.ceil(Math.random() * (max - min)) + min;

function environment_information(
  state = Map({
    isFetching: true,
    launchError: "",
    games: List(),
    filteredGames: List(),
    favouriteGames: List(),
    orderedGames: List(),
    launchOptions: Map({
      token: "token-gbp_user_" + tokenID,
      language: "en",
      ccy: "GBP",
      mode: "",
      host: "",
      game: "",
      variant: "",
      extraParams: "",
    }),
    urlLaunchOptions: OrderedMap({
      hostDomain: "",
      gamesLocation: "games/",
      lobbyURL: "",
      depositURL: "",
      realplayURL: "https://www.playzido.com",
      showMenuButton: true,
      minimumTimeBetweenSpinRequests: 0,
      forceTimeBetweenSpins: false,
      allowDevTools: true,
      logEndPoint: "",
      hostPathConfig: "",
      localeFilesPath: "",
      stylesFiles: List([""]),

      wrapperHelpLocation: "",

      portraitSupport: true,
      landscapeSupport: true,

      demoMode: false,

      startMuted: false,

      languages: OrderedMap({
        fallback: true,
        supported: ["en", "pt"],
      }),

      "menu-options": OrderedMap({
        sound: true,
        paytable: true,
        help: true,
        turbo: false,
        lobby: true,
        deposit: true,
        realPlay: true,
        backgroundSound: true,
      }),

      components: OrderedMap({
        infoBar: true,
        gameplayID: true,
        clock: true,
        clockPosition: "infobar",
        clockVerticalPosition: "top",
        infoBarPosition: "bottom",
        infoBarOverlay: false,
        infoBarStake: true,
        infoBarCurrentBalance: true,
        infoBarTotalWin: true,
        infoBarSplitBalance: true,
      }),

      autoplay: OrderedMap({
        hasStakeOption: true,
        numberPlays: [0, 2, 5, 10, 15, 20, 25, 50, 100],
        maximumNumberPlays: 100,
        lossLimitMultiplier: [5, 10, 15, 20, 25, 50, 100, -1],
        lossLimitMandatory: false,
        singleWinLimitMultiplier: [5, 10, 15, 20, 25, 50, 100, -1],
        singleWinLimitMandatory: true,
        jackpotWinVisible: false,
        jackpotWinDefaultValue: "off",
        onBonusFeature: false,
      }),

      showPromoScreen: true,
      spinsToPromo: 100,
      timeToPromo: 900,

      realityCheckExitToLobby: false,
      realityCheckExitURL: "",
      realityCheckHistoryURL: "",

      realityCheckCurrentTime: 0,
      realityCheckInterval: 0,
      realityCheckTimeUnit: "seconds",

      urlRedirectsDesktop: true,
      urlRedirectsMobile: true,

      iframe: OrderedMap({
        domain: "",
      }),

      demoForceEnabled: false,
      "450fatal": true,
      networkErrorAsFatal: true,

      freeBets: OrderedMap({
        maybeLaterTimeout: 4000,
        winTimeout: 4000,
      }),

      launcherTimeout: 1000,
      splitBalancePopUpTimeout: 4000,

      jurisdiction: OrderedMap({
        agcc: OrderedMap({
          showMessage: true,
        }),
      }),

      externalJSFilesToLoad: "",

      showDevToolsButton: false,
      showCappedWinningsPopUp: false,

      interface: "",
      pubsubLog: false,
      showTrailingZeros: true,
      preventMouseTouchEvents: false,
      gameHasSplash: false,

      refreshDesktop: true,
      refreshMobile: true,
    }),
    config,
    qaLinks,
    isSortAtoZ: undefined,
    filterMode: store.get("filterMode") || "all",
  }),
  action
) {
  let games = List();
  let favouriteGames = List();
  let orderedGames = List();

  switch (action.type) {
    case GET_GAMES:
      return state.update("isFetching", (isFetching) => true);

    case SET_LAUNCH_ERROR:
      return state.update("launchError", (launchError) => action.game);

    case RECEIVE_GAMES:
      games = fromJS(action.games.games); // games here will be deleted as we match favourite games
      favouriteGames = fromJS(action.games.favouriteGames);
      orderedGames = List();

      // re-order games
      // by placing the favourite ones at the beginning
      // and removing those from the games variable
      // so we can concat orderedGames
      favouriteGames.forEach((favouriteGame) => {
        orderedGames = orderedGames.push(favouriteGame);
        games = games.remove(
          games.findIndex((game) => game.get("id") === favouriteGame.get("id"))
        );
      });

      state = state.set("games", fromJS(action.games.games));
      state = state.set("favouriteGames", fromJS(action.games.favouriteGames));
      state = state.set("orderedGames", orderedGames.concat(games));
      state = state.set("isFetching", false);

      return state;

    case RECEIVE_OGA_INFORMATION:
      return state.set("oga_version", action.oga_version);

    case SET_LAUNCH_OPTIONS:
      console.log(
        "setting " + action.options.name + " to: " + action.options.value
      );

      let newLaunchOptions = state.get("launchOptions");
      newLaunchOptions = newLaunchOptions.set(
        action.options.name,
        action.options.value
      );
      state = state.update(
        "launchOptions",
        (launchOptions) => newLaunchOptions
      );
      return state;

    case SET_URL_LAUNCH_OPTIONS:
      let newUrlLaunchOptions = state.get("urlLaunchOptions");
      let newName = action.options.name;

      // we often get action.options.name as ["parent", "child"] in case of nested
      // such as components.infoBar
      // but in the case of something deeper
      // such as jurisdiction.agcc.showMessage
      // we will receive ["jurisdiction.agcc", "showMessage"]
      // and in such cases we want to split the first position of the array
      // so that it becomes like so:
      // ["jurisdiction", "agcc"]
      // and then we concat with the other part of the array
      // ["jurisdiction", "agcc", "showMessage"]
      if (newName[0].indexOf(".") > -1) {
        newName = newName[0].split(".").concat(action.options.name[1]);
      }

      newUrlLaunchOptions = newUrlLaunchOptions.setIn(
        newName,
        fromJS(action.options.value)
      );
      state = state.update(
        "urlLaunchOptions",
        (urlLaunchOptions) => newUrlLaunchOptions
      );
      return state;

    case FILTER_GAMES:
      state = state.update("filteredGames", () => action.games);
      return state;

    case TOGGLE_FAVOURITE_GAME:
      games = state.get("games");
      favouriteGames = fromJS(action.favouriteGames);
      orderedGames = List();

      // re-order games
      // by placing the favourite ones at the beginning
      // and removing those from the games variable
      // so we can concat orderedGames
      favouriteGames.forEach((favouriteGame) => {
        orderedGames = orderedGames.push(favouriteGame);
        games = games.remove(
          games.findIndex((game) => game.get("id") === favouriteGame.get("id"))
        );
      });

      state = state.set("favouriteGames", fromJS(action.favouriteGames));
      state = state.set("orderedGames", orderedGames.concat(games));

      return state;

    case SET_SORT_A_TO_Z:
      state = state.set("isSortAtoZ", true);
      state = state.set("filteredGames", action.games);
      return state;

    case SET_SORT_Z_TO_A:
      state = state.set("isSortAtoZ", false);
      state = state.set("filteredGames", action.games);
      return state;

    case SET_FILTER_MODE_TO_ALL:
      state = state.set("filterMode", "all");
      store.set("filterMode", "all");
      return state;

    case SET_FILTER_MODE_TO_REAL:
      state = state.set("filterMode", "real");
      store.set("filterMode", "real");
      return state;

    case SET_FILTER_MODE_TO_DEMO:
      state = state.set("filterMode", "demo");
      store.set("filterMode", "demo");
      return state;

    default:
      return state;
  }
}

const rootReducer = combineReducers({
  environment_information,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js